// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".global-comment[data-v-0a135d9c] {\n  position: absolute;\n  bottom: 2rem;\n}\n.global-comment-default[data-v-0a135d9c] {\n  right: 3rem;\n}\n.global-comment-info-tab-active[data-v-0a135d9c] {\n  right: 25rem;\n}", ""]);
// Exports
module.exports = exports;
